import Utils from '@/common/utils';
import Errors from '@/common/errors';
import Api from '@/biz/api';
import ProcessData from '@/biz/processData';
import Report from '@/common/report';
import reportConfig from '@/config/report.config';
import Enums from '@/config/enums.config';
import errorConfig from '@/config/errors.config';

//important 因为所有文件同名，所以必须要加上文件类型
import SortTab from '@/components/SortTab/SortTab.vue';
import SortSelectBtn from '@/components/SortSelectBtn/SortSelectBtn.vue';
import WishItem from '@/components/WishItem/WishItem.vue';
import Toast from '@/components/Toast/Toast.vue';
import PopUp from '@/components/PopUp/PopUp.vue';
import HalfScreen from '@/components/HalfScreen/HalfScreen.vue';

import SubscribeMixin from '@/mixins/subscribe.js';
import Config from '@/config/act.config';

export default {
  name: 'PickWish',
  mixins: [SubscribeMixin],
  components: {
    SortTab,
    SortSelectBtn,
    WishItem,
    Toast,
    PopUp,
    HalfScreen
  },
  data: function() {
    return {
      curStep: 0,
      curSort: 0,
      isSimple: true,
      wishList: [],
      simpleWishList: [],
      complexWishList: [],
      wishIdList: [],
      popUpConfig: {},
      toastConfig: {},
      colorStyle: 'light',
      sortBtnList: [],
      sortTabList: [],
      selectedWishIndex: {},
      // 订阅时间线提示配置
      halfScreenConfig: {
        isShow: false
      },
      halfScreenSlotType: '',
      stageList: [],
      stageArray: [],
      // 2023 新增
      hideShareGiftEntrance: false, // 是否隐藏有福同享入口
      shareGiftEntranceInfo: null // 有福同享入口信息
    };
  },
  computed: {
    pickWishClassList() {
      return [
        'pick-wish',
        this.isSimple ? 'pick-wish_simple' : '',
        (this.complexWishList[this.curStep]
        ? this.complexWishList[this.curStep].withSortTab
        : false)
          ? 'pick-wish_sort'
          : '',
        'container'
      ];
    },
    isCompleted() {
      if (this.isSimple) {
        return Object.keys(this.selectedWishIndex).length === this.simpleWishList.length;
      } else {
        return Object.keys(this.selectedWishIndex).length === this.complexWishList.length;
      }
    },
    isInProgress() {
      if (
        Object.keys(this.selectedWishIndex).length > 0 &&
        Object.keys(this.selectedWishIndex).length < this.complexWishList.length
      ) {
        let fullStatus = true;
        this.sortBtnList.forEach((item) => {
          if (!item.isSelected && !item.isCur) {
            fullStatus = false;
          }
        });
        return !fullStatus;
      } else {
        return false;
      }
    },
    makeWishSimpleClassList() {
      return ['btn', 'btn_l', 'pick-wish__btn-wish-simple', this.isCompleted ? '' : 'btn_disable'];
    },
    makeWishComplexClassList() {
      return [
        'btn',
        'btn_m',
        'pick-wish__btn-wish-complex',
        this.isCompleted || this.isInProgress ? '' : 'btn_disable'
      ];
    },
    mainButtonText() {
      return this.isInProgress ? '下一个' : '许下心愿';
    },
    wishType() {
      return this.isSimple ? 'simple' : 'complex';
    },
    nextLevelTitle() {
      let theTitle = '';
      if (this.isSimple) {
        let levelLength = this.simpleWishList.length;
        for (let i = levelLength - 1; i >= 0; i--) {
          if (this.selectedWishIndex[i] === undefined) {
            theTitle = this.simpleWishList[i].title;
          }
        }
      } else {
        theTitle = this.complexWishList[this.curStep].title;
      }

      return theTitle;
    },
    // 2023 新增
    // 是否显示有福同享半屏
    isShowShareGiftHalfScreen() {
      const isVisited = localStorage.getItem('shake_spring_share_lucky') === '1';
      return !isVisited && !this.hideShareGiftEntrance;
    }
  },
  methods: {
    //点击半屏中的按钮
    halfScreenBtnClickHandler(param) {
      let btnOperation = param.btnOperation;
      switch (btnOperation) {
        case 'close':
          // 关闭半屏
          // 根据不同slot进行不同操作
          if (this.halfScreenSlotType === 'timeline') {
            this.closeSubscriptionTimeline();
          } else if (this.halfScreenSlotType === 'notification') {
            this.closeSubscriptionNotification();
          } else if (this.halfScreenSlotType === 'friends_blessing') {
            this.closeFriendsBlessing();
          }
          break;
        case 'subscribe-timeline':
          // 订阅活动开始
          this.subscribe();
          break;
        // 2023 新增
        // 打开有福同享页面
        case 'open-share-gift':
          this.openShareGift();
          // 关闭当前页面
          this.closePageHandler();
          break;
        default:
          break;
      }
    },

    // 直接关闭时间线订阅
    closeSubscriptionTimeline() {
      this.halfScreenConfig = { isShow: false };
      // this.closePageHandler();
      // 2023 调整逻辑，进入有福同享逻辑
      if (this.isShowShareGiftHalfScreen) {
        this.showFriendsBlessing();
      } else {
        this.closePageHandler();
      }
    },

    // 关闭订阅成功提示
    closeSubscriptionNotification() {
      this.halfScreenConfig = { isShow: false };
      // this.closePageHandler();
      // 2023 调整逻辑，进入有福同享逻辑
      if (this.isShowShareGiftHalfScreen) {
        this.showFriendsBlessing();
      } else {
        this.closePageHandler();
      }
    },
    // 订阅
    subscribe() {
      if (!this.isActOpenSubscribed) {
        this.halfScreenConfig = { isShow: false };
        this.subscribeAction(() => {
          this.halfScreenSlotType = 'notification';
          Report.batch10861({
            actId: this.actId,
            openId: this.openId,
            appId: this.appId,
            pid: reportConfig.PICK_WISH.PID,
            pos: reportConfig.PICK_WISH.POSITION.BUTTON_SUBSCRIBE_TOP,
            action: reportConfig.ACTION.SUBSCRIBE
          });
        });

        Report.batch10861({
          actId: this.actId,
          openId: this.openId,
          appId: this.appId,
          pid: reportConfig.PICK_WISH.PID,
          pos: reportConfig.PICK_WISH.POSITION.BUTTON_SUBSCRIBE_TOP,
          action: reportConfig.ACTION.BUTTON_CLICK
        });
      }
    },

    // 向上层传递活动状态（内测，活动结束等等）
    emitActTimeSection(res) {
      let actConfig = res.data.act_config;
      let timeSectionList = actConfig.time_section_list;
      let timeSection;
      timeSectionList.forEach((item) => {
        if (item.is_current) {
          timeSection = item;
        }
      });

      if (timeSection && timeSection.is_current) {
        // 该页面内测开启时不展示公示
        if (timeSection.time_section_type !== Enums.TIME_SECTION_TYPE.BETA_OPEN) {
          this.$emit('have-act-status', {
            timeSection,
            openId: actConfig.openid,
            actId: actConfig.act_id,
            subscriptionId: actConfig.subscribe_id
          });
        }
      }
    },

    // 获取活动相关配置信息
    getActConfig() {
      return new Promise((resolve) => {
        Api.getSpringFestivalActConfig({
          req: {
            platid: WXGAME.Env.isAndroid ? 1 : 0
          }
        }).then((res) => {
          if (res.data && res.errcode === 0) {
            if (res.data.act_config) {
              let actConfig = res.data.act_config;
              this.actId = actConfig.act_id;
              this.openId = actConfig.openid;
              this.stageList = actConfig.stage_list;

              this.setStageArray();

              this.timeSectionId = actConfig.current_time_section.section_id;
              this.subscriptionOptions.subscriptionId = actConfig.subscribe_id;

              this.stageType = actConfig.stage_type || 0;
              // 如果是只能许愿阶段，外抛事件
              if (this.stageType === Enums.STAGE_TYPE.ONLY_WISH) {
                this.$emit('only-wish');
              }

              // 2023 新增逻辑
              this.hideShareGiftEntrance = actConfig.off_share_gift || false;

              resolve(res);
            }
          } else {
            this.popUpConfig = Utils.alertError(
              Errors.getMessage(res.errcode),
              res.errcode,
              res.errmsg
            );
          }
        });
      });
    },

    // 获取游戏心愿列表
    getGameWishList() {
      Api.getSpringFestivalWishConfig({
        req: {
          appid: Utils.getQueryStr('appid') || '',
          is_global: false
        }
      })
        .then((res) => {
          if (res.data && res.errcode === 0) {
            //简单模板还是复杂模板
            this.isSimple = res.data.wish_type === 1;

            if (this.isSimple) {
              this.simpleWishList = ProcessData.simpleWishList(res.data.level_wish_list);

              // 根据返回的数据判断是否填充已选栏
              this.simpleWishList.forEach((simpleWish, moduleIndex) => {
                simpleWish.wishList.forEach((wish, wishIndex) => {
                  if (wish.isCur) {
                    this.selectedWishIndex[moduleIndex] = wishIndex;
                  }
                });
              });
            } else {
              let complexData = ProcessData.complexWishList(res.data.level_wish_list);
              this.complexWishList = complexData.wishList;
              this.sortTabList = complexData.sortTabList;
              this.sortBtnList = complexData.sortBtnList;

              //设定 btn 和 tag 的初始状况
              this.sortBtnList[this.curStep].isCur = true;
              this.sortTabList[this.curStep][this.curSort].isCur = true;
            }
          } else {
            this.$emit('load-error', { errorCode: res.errcode });
          }
          this.$emit('load-complete');
        })
        .catch((res) => {
          if (res && typeof res === 'string' && res.search('401') > -1) {
            location.replace(
              window.location.origin +
                window.location.pathname +
                '?path=pick_wish&appid=' +
                this.appId +
                '&nav_color=FF7A5A&darkmode_nav_color=FF7A5A&' +
                Config.globalQueries
            );
          } else {
            this.$emit('load-error', { errorCode: 1 });
            this.$emit('load-complete');
          }
        });
    },

    // 点击单项心愿
    wishItemClickHandler(e) {
      // 更新当前心愿内容索引
      let curWishItemIndex = Number(e.currentTarget.dataset.wishItemIndex);

      if (this.isSimple) {
        // 简单模式，依据 module index
        let moduleIndex = Number(e.currentTarget.dataset.moduleIndex);

        // 清除原有状态
        if (this.selectedWishIndex[moduleIndex] !== undefined) {
          this.simpleWishList[moduleIndex].wishList[
            this.selectedWishIndex[moduleIndex]
          ].isCur = false;
        }
        // 设定现有状态
        this.selectedWishIndex[moduleIndex] = curWishItemIndex;
        this.simpleWishList[moduleIndex].wishList[this.selectedWishIndex[moduleIndex]].isCur = true;
      } else {
        // 复杂模式，依据 step , sort ,index
        // 清除原有状态
        if (this.selectedWishIndex[this.curStep] !== undefined) {
          this.complexWishList[this.curStep].tagWishList[this.selectedWishIndex[this.curStep][0]][
            this.selectedWishIndex[this.curStep][1]
          ].isCur = false;
        }

        // 设定现有状态
        this.selectedWishIndex[this.curStep] = [this.curSort, curWishItemIndex];
        this.complexWishList[this.curStep].tagWishList[this.selectedWishIndex[this.curStep][0]][
          this.selectedWishIndex[this.curStep][1]
        ].isCur = true;

        // 对应 sortBtn 也更换
        this.sortBtnList[this.curStep].isSelected = true;
        this.sortBtnList[this.curStep].imageUrl = this.complexWishList[this.curStep].tagWishList[
          this.selectedWishIndex[this.curStep][0]
        ][this.selectedWishIndex[this.curStep][1]].imageUrl;

        this.sortBtnList[this.curStep] = Object.assign({}, this.sortBtnList[this.curStep]);
      }

      // 对象新增属性， vue 无法检测，需要这样处理
      this.selectedWishIndex = Object.assign({}, this.selectedWishIndex);
    },

    // 点击许下心愿（下一个）按钮
    makeWishBtnClickHandler() {
      if (this.isCompleted) {
        this.showMakeSureMakeWishPopup();
      } else {
        if (this.isSimple) {
          this.toastConfig = {
            isShow: true,
            strongText: this.nextLevelTitle,
            text: '还未选择哦'
          };

          setTimeout(() => {
            this.toastConfig = {
              isShow: false
            };
          }, 2000);
        } else {
          if (this.isInProgress) {
            // 复杂模板已经激发了选择流程
            // 自动跳转到下一个未选择类别
            this.goToNextStep();
          } else {
            this.toastConfig = {
              isShow: true,
              strongText: this.nextLevelTitle,
              text: '还未选择哦'
            };

            setTimeout(() => {
              this.toastConfig = {
                isShow: false
              };
            }, 2000);
          }
        }
      }
    },

    // 去下一个未选择的礼物层级
    goToNextStep() {
      let nextStep;
      for (let i = this.sortBtnList.length - 1; i >= 0; i--) {
        if (!this.sortBtnList[i].isSelected) {
          nextStep = i;
        }
      }
      this.changeSortLevel(nextStep);
    },

    // 显示确认浮层
    showMakeSureMakeWishPopup() {
      this.popUpConfig = {
        isShow: true,
        type: 'normal',
        data: {
          title: '许下该游戏心愿后，就不能更换了哦',
          btnList: [
            {
              btnText: '再想想',
              btnOperation: 'close',
              isSub: true
            },
            {
              btnText: '选好了',
              btnOperation: 'doMakeWish',
              isSub: false
            }
          ]
        }
      };
    },

    // 确认许下心愿
    doMakeWish() {
      let wishIdList = [];

      // 生成心愿id 数组
      if (this.isSimple) {
        this.simpleWishList.forEach((module, moduleIndex) => {
          wishIdList.push(module.wishList[this.selectedWishIndex[moduleIndex]].wishId);
        });
      } else {
        this.complexWishList.forEach((step, stepIndex) => {
          wishIdList.push(
            step.tagWishList[this.selectedWishIndex[stepIndex][0]][
              this.selectedWishIndex[stepIndex][1]
            ].wishId
          );
        });
      }

      this.setMyGameWishes(wishIdList);

      // 上报确认许下心愿
      Report.batch10861({
        actId: this.actId,
        openId: this.openId,
        pid: reportConfig.PICK_WISH.PID,
        pos: reportConfig.PICK_WISH.POSITION.BUTTON_MAKE_SURE,
        action: reportConfig.ACTION.BUTTON_CLICK,
        appId: this.appId
      });
    },

    // 许下游戏心愿
    setMyGameWishes(wishIdList) {
      Api.setMySpringFestivalWish({
        req: {
          appid: this.appId,
          wish_id_list: wishIdList,
          is_global: false,
          time_section_id: this.timeSectionId,
          plat_type: WXGAME.Env.isiOS ? Enums.PLATFORM.IOS : Enums.PLATFORM.ANDROID
        }
      })
        .then((res) => {
          if (res.data && res.errcode === 0) {
            wishIdList.forEach((item) => {
              // 上报许愿成功
              Report.batch10861({
                actId: this.actId,
                openId: this.openId,
                pid: reportConfig.PICK_WISH.PID,
                pos: reportConfig.PICK_WISH.POSITION.BUTTON_MAKE_SURE,
                action: reportConfig.ACTION.MAKE_SURE,
                appId: this.appId,
                giftId: item
              });
            });

            if (!this.isActOpenSubscribed && this.stageType !== Enums.STAGE_TYPE.ALL_GAME) {
              // 成功许愿后显示订阅提示
              this.showSubscribeTimeline();
            } else {
              // this.closePageHandler();
              // 2023 调整逻辑，进入有福同享逻辑
              if (this.isShowShareGiftHalfScreen) {
                this.showFriendsBlessing();
              } else {
                this.closePageHandler();
              }
            }
          } else {
            if (
              res.errcode === errorConfig.code.ERR_TIME_NOT_BEGIN ||
              res.errcode === errorConfig.code.ERR_TIME_END
            ) {
              // 内测已经结束或活动已经结束
              // 重新拉配置信息，抛出
              this.getActConfig().then((res) => {
                this.emitActTimeSection(res);
              });
            } else {
              this.showErrorPopup(res);
            }
          }
        })
        .catch((res) => {
          if (res && typeof res === 'string' && res.search('401') > -1) {
            // 未授权状态
            location.replace(
              window.location.origin +
                window.location.pathname +
                '?path=pick_wish&appid=' +
                this.appId +
                '&nav_color=FF7A5A&darkmode_nav_color=FF7A5A&' +
                Config.globalQueries
            );
          }
        });
    },

    // 时间线说明的订阅提示
    showSubscribeTimeline() {
      this.halfScreenSlotType = 'timeline';
      this.halfScreenConfig = {
        isShow: true,
        type: 'normal',
        slotType: 'subscribe-timeline',
        withClose: true,
        title: '摇心愿订阅',
        btnList: [
          {
            btnOperation: 'subscribe-timeline',
            btnText: this.isActOpenSubscribed ? '已订阅通知' : '订阅活动通知',
            type: 'primary',
            size: 'large',
            isDisable: this.isActOpenSubscribed
          }
        ]
      };
    },

    // 对于跨时间段问题的错误码和普通错误码的处理
    showErrorPopup(res) {
      this.popUpConfig = Utils.alertError(Errors.getMessage(res.errcode), res.errcode, res.errmsg);

      if (
        res.errcode === errorConfig.code.ERR_TIME_SECTION_MINIGAME_NORMAL_ONE ||
        res.errcode === errorConfig.code.ERR_TIME_SECTION_DDZ_NORMAL_ONE ||
        res.errcode === errorConfig.code.ERR_TIME_SECTION_LOLM_NORMAL_ONE ||
        res.errcode === errorConfig.code.ERR_TIME_SECTION_PUBG_NORMAL_ONE ||
        res.errcode === errorConfig.code.ERR_TIME_SECTION_MOBA_NORMAL_ONE
      ) {
        // 许愿不在对应阶段
        // 在王者时间段许下和平心愿才会出现
        // 此时关闭页面，回到  make_wish
        this.popUpConfig.data.title = '游戏专场结束了，去许下更多心愿吧';
        this.popUpConfig.data.btnList = [
          {
            btnText: '去许愿',
            btnOperation: 'backToMakeWish'
          }
        ];
      }
    },

    // 切换礼物分类
    changeSortTab(params) {
      // 原有分类去掉当前态
      this.sortTabList[this.curStep][this.curSort].isCur = false;

      // 切换当前分类索引
      this.curSort = params.curTabIndex;

      // 现有分类添加当前态
      this.sortTabList[this.curStep][this.curSort].isCur = true;

      // 对滚动进行还原
      if (this.scrollEle && this.scrollEle.scrollTop !== undefined) {
        this.scrollEle.scrollTop = 0;
      }
    },

    // 点击礼物级别按钮
    sortBtnItemClickHandler(e) {
      let targetIndex = e.currentTarget.dataset.sortBtnIndex;
      this.changeSortLevel(targetIndex);

      // 对滚动进行还原
      if (this.scrollEle && this.scrollEle.scrollTop !== undefined) {
        this.scrollEle.scrollTop = 0;
      }
    },

    // 切换礼物级别
    changeSortLevel(sortBtnIndex) {
      // 原有级别去掉当前态
      this.sortBtnList[this.curStep].isCur = false;
      // 原有分类去掉当前态
      this.sortTabList[this.curStep][this.curSort].isCur = false;

      this.sortBtnList[this.curStep] = Object.assign({}, this.sortBtnList[this.curStep]);

      // 切换当前级别索引
      this.curStep = sortBtnIndex;
      this.curSort = 0;

      // 现有级别添加当前态
      this.sortBtnList[this.curStep].isCur = true;
      // 现有级别下分类初始化
      this.sortTabList[this.curStep][this.curSort].isCur = true;

      this.sortBtnList[this.curStep] = Object.assign({}, this.sortBtnList[this.curStep]);
    },

    // 浮层按钮处理
    popUpBtnClickHandler(params) {
      let btnOperation = params.btnOperation;
      switch (btnOperation) {
        case 'close':
          this.closePopUp();
          break;
        case 'doMakeWish':
          this.doMakeWish();
          this.closePopUp();
          break;
        case 'backToMakeWish':
          this.closePageHandler();
          break;
        default:
          break;
      }
    },

    // 关闭页面给个延时
    closePageHandler() {
      setTimeout(() => {
        this.closePage();
      }, 300);
    },

    // 关闭当前页面
    closePage() {
      // 如果回调结果不是ok，则重复调用
      WXGAME.WxBridge.invoke('closeWindow', {}, (e) => {
        if (e.err_msg !== 'close_window:ok') {
          this.closePage();
        }
      });
    },

    // 关闭浮层
    closePopUp() {
      this.popUpConfig = {};
    },

    // 设置 stageArray
    setStageArray() {
      let tmpStageArray = [];
      if (this.stageList) {
        this.stageList.forEach((stageItem, stageIndex) => {
          let targetStage = {
            title: stageItem.title,
            isCurrent: stageItem.is_current || false,
            children: [
              {
                day: stageItem.day,
                isCurrent: stageItem.is_current || false
              }
            ]
          };

          // 判断是否是游戏的专场
          if (stageItem.app_icon) {
            // 是游戏的专场
            // 检查上一个是否是游戏的
            if (this.stageList[stageIndex - 1] && this.stageList[stageIndex - 1].app_icon) {
              // 上一个是的，则在当前stageList的children中直接添加
              let tmpChild = {
                day: stageItem.day,
                isCurrent: stageItem.is_current || false,
                gameIcon: stageItem.app_icon
              };
              tmpStageArray[tmpStageArray.length - 1].children.push(tmpChild);
              // 如果有单项是true，则重置整体当前态
              tmpStageArray[tmpStageArray.length - 1].isCurrent = stageItem.is_current
                ? true
                : tmpStageArray[tmpStageArray.length - 1].isCurrent;
            } else {
              // 不是，则用新建的项目
              targetStage.children[0].gameIcon = stageItem.app_icon;

              // 存入数组
              tmpStageArray.push(targetStage);
            }
          } else {
            // 存入数组
            tmpStageArray.push(targetStage);
          }
        });
      }
      this.stageArray = tmpStageArray;
    },

    // 2023 新增
    // 显示有福同享半屏
    showFriendsBlessing() {
      this.halfScreenSlotType = 'friends_blessing';
      this.halfScreenConfig = {
        isShow: true,
        className: 'friends_blessing',
        type: 'normal',
        slotType: 'friends_blessing',
        withClose: true,
        btnList: [
          {
            btnOperation: 'open-share-gift',
            btnText: '去领取',
            type: 'primary',
            size: 'large'
          }
        ]
      };
    },
    // 关闭有福同享半屏
    closeFriendsBlessing() {
      this.halfScreenConfig = { isShow: false };
      this.closePageHandler();
    },
    // 获取有福同享入口信息
    getShareGiftEntranceInfo() {
      Api.getShareGiftEntranceInfo({
        req: {}
      })
        .then((res) => {
          if (res.data && res.errcode === 0) {
            this.shareGiftEntranceInfo = res.data || {};
          } else {
            // 如果获取信息失败则隐藏入口
            this.hideShareGiftEntrance = true;
          }
        })
        .catch((e) => {
          // 如果获取信息失败则隐藏入口
          this.hideShareGiftEntrance = true;
        });
    },
    // 打开有福同享页面
    openShareGift() {
      Report.batch10861({
        actId: this.actId,
        openId: this.openId,
        appId: this.appId,
        pid: reportConfig.PICK_WISH.PID,
        pos: reportConfig.PICK_WISH.POSITION.BUTTON_OPEN_FRIEND_SHARE,
        action: reportConfig.ACTION.LINK
      });

      WXGAME.openUrl(Config.jumpUrl.shareGift, {
        instance_id: this.shareGiftEntranceInfo?.share_instanceid,
        noticeid: 66043145,
        ssid: 8888
      });
    }
  },
  mounted: function() {
    this.appId = Utils.getQueryStr('appid') || '';

    //增加鉴权
    WXGAME.WxBridge.verifyJsapi(
      WXGAME.WxBridge.apis.concat(['setNavigationBarColor', 'setPageTitle']),
      function(res) {
        WXGAME.WxBridge.invoke(
          'setNavigationBarColor',
          { color: Config.navBarColor.wish },
          (res) => {}
        );
        WXGAME.WxBridge.invoke(
          'setPageTitle',
          { color: Config.navBarColor.wishTitle },
          (res) => {}
        );
      }
    );

    this.getActConfig().then((res) => {
      this.subscriptionOptions.subscriptionId = res.data.act_config.subscribe_id;
      this.initSubscription();
      this.emitActTimeSection(res);

      this.scrollEle = document.querySelector('.pick-wish');

      // 2023 新增
      // 如果要显示有福同享入口且未访问过，则执行对应请求
      if (this.isShowShareGiftHalfScreen) {
        this.getShareGiftEntranceInfo();
      }

      Report.batch10861({
        actId: this.actId,
        openId: this.openId,
        appId: this.appId,
        pid: reportConfig.PICK_WISH.PID,
        pos: reportConfig.PICK_WISH.POSITION.PAGE,
        action: reportConfig.ACTION.EXPOSURE
      });
    });
    this.getGameWishList();
  },
  created: function() {}
};
